import GenericHero from "../../components/GenericHero/GenericHero";
import "./ProjectsPage.scss";
import deskHello from "../../assets/images/deskHello.svg";
import DeviceMock from "../../components/DeviceMock/DeviceMock";
import laptopGrace from "../../assets/images/laptopGrace.png";
import laptopFFWBCW from "../../assets/images/laptopFFWBCW.png";
import laptotopHereBoy from "../../assets/images/laptopHereBoy.png";

export default function ProjectsPage() {
  return (
    <div className="projectspage">
      <GenericHero
        head="Projects"
        text="Bringing user-friendly designs and robust functionality together, each project below highlights my dedication to creating digital experiences that my clients can be proud of. Take a look at some of my work below or request a free quote to get started."
        hImg={deskHello}
        hAlt="Graphic with multiple blank devices"
        btnContent="View Projects"
        btnLink="#projects"
        btn2Content="Request a Quote"
        btn2Link="#contact"
      />
      <div id="projects"></div>
      <DeviceMock
        dHeader="More of Grace"
        dAlt="A mockup of the website moreofgrace.org on a laptop"
        dDesc="With this project, I delivered an online presence with a timeless design, built a robust sermon database, and developed a streamlined admin panel. By restructuring the codebase from the ground up, I created a user-friendly experience tailored to both the church’s visitors and its team."
        dImg={laptopGrace}
        dLink="/project/moreofgrace"
      />
      <DeviceMock
        dHeader="Here Boy"
        dAlt="A mockup of the website hereboycodechallenge.netlify.app on a laptop"
        dDesc="This is a coding challenge to create a fake dog adoption website, HereBoy! Users can log in, search the dog database, tag their favorites, and find their perfect match!"
        dImg={laptotopHereBoy}
        dLink="/project/hereboy"
      />
      <DeviceMock
        dHeader="First Free Will Baptist Waverly"
        dAlt="A mockup of the website ffwbcw.org on a laptop"
        dDesc="For this project I designed and delivered a React Application that provides a user-friendly and intuitive online presence for First Free Will Baptist. Working closely with the pastor, I created a design that reflects the church’s unique identity and values, ensuring it resonates with their congregation."
        dImg={laptopFFWBCW}
        dLink="/project/ffwbcw"
      />
    </div>
  );
}
